import React, { useEffect } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import Gallery from "@/components/site/Gallery";
import About from "@/components/site/About";
import Reviews from "@/components/site/Reviews";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyMobileCall from "@/components/site/StickyMobileCall";

export default function Landing() {
  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add("is-visible");
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -60px 0px" }
    );
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-[var(--bg)]">
      <Header />
      <main>
        <Hero />
        <Services />
        <Gallery />
        <About />
        <Reviews />
        <Contact />
      </main>
      <Footer />
      <StickyMobileCall />
    </div>
  );
}
